import api from './services/mkm.api.js'

const resource = '/gesamtabrechnung';

export default {
    senden(payload) {
        return api.post(resource, payload);
    },
    byhash(hash) {
        return api.get(`${resource}/byhash/${hash}`)
    }
}